import { render, staticRenderFns } from "./TenantDetail.vue?vue&type=template&id=01498f48&scoped=true&"
import script from "./TenantDetail.vue?vue&type=script&lang=js&"
export * from "./TenantDetail.vue?vue&type=script&lang=js&"
import style0 from "./TenantDetail.vue?vue&type=style&index=0&id=01498f48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01498f48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01498f48')) {
      api.createRecord('01498f48', component.options)
    } else {
      api.reload('01498f48', component.options)
    }
    module.hot.accept("./TenantDetail.vue?vue&type=template&id=01498f48&scoped=true&", function () {
      api.rerender('01498f48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/settings/tenants/TenantDetail.vue"
export default component.exports